<template>
  <main>
    <img src="/logo.svg" alt="" class="logo">
    <slot />
  </main>
</template>

<script lang="ts" src="./AuthLayout.ts"></script>

<style scoped lang="scss" src="./AuthLayout.scss"></style>
